import type { ActivitySession } from "@learn-flow/contracts";

export const maximumDisplayedPlannedSessions = 3;

export type PlannedActivitySessions = {
  displayed: ActivitySession[];
  remainingCount: number;
};

export function selectPlannedActivitySessions(
  sessions: ActivitySession[],
): PlannedActivitySessions {
  const scheduled = sessions
    .filter((session) => session.status === "scheduled")
    .toSorted(compareActivitySessions);

  return {
    displayed: scheduled.slice(0, maximumDisplayedPlannedSessions),
    remainingCount: Math.max(0, scheduled.length - maximumDisplayedPlannedSessions),
  };
}

export function selectCurrentActivitySession(
  sessions: ActivitySession[],
  intendedSessionId: string | null,
): ActivitySession | null {
  const intended = intendedSessionId
    ? (sessions.find((session) => session.id === intendedSessionId) ?? null)
    : null;
  if (intended) return intended;
  return (
    sessions
      .filter((session) => session.status === "scheduled")
      .toSorted(compareActivitySessions)[0] ?? null
  );
}

export function selectOtherUpcomingSessions(
  sessions: ActivitySession[],
  currentSessionId: string | null,
  today: string,
): ActivitySession[] {
  return sessions
    .filter(
      (session) =>
        session.status === "scheduled" &&
        session.id !== currentSessionId &&
        session.scheduledDate >= today,
    )
    .toSorted(compareActivitySessions);
}

export function compareActivitySessions(left: ActivitySession, right: ActivitySession): number {
  return (
    `${left.scheduledDate}T${left.scheduledTime ?? ""}`.localeCompare(
      `${right.scheduledDate}T${right.scheduledTime ?? ""}`,
    ) ||
    left.createdAt.localeCompare(right.createdAt) ||
    left.id.localeCompare(right.id)
  );
}
